import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InventoryLocationsSettingComponent } from './inventory-locations-setting.component';
import { BadgeModule } from 'src/app/shared/components/badge/badge.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { InventoryLocationsTableComponent } from './inventory-locations-table/inventory-locations-table.component';
import { WarningDialogModule } from 'src/app/shared/components/warning-dialog/warning-dialog.module';
import { TabsModule } from 'src/app/shared/components/tabs/tabs.module';
import { MenuModule } from 'src/app/shared/components/menu/menu.module';
import { AddEditInventoryLocationDialogModule } from '../dialogs/add-edit-inventory-location-dialog/add-edit-inventory-location-dialog.module';



@NgModule({
  declarations: [InventoryLocationsSettingComponent, InventoryLocationsTableComponent],
  imports: [
    CommonModule,
    BadgeModule,
    ButtonModule,
    WarningDialogModule,
    BadgeModule,
    TabsModule,
    MenuModule,
    AddEditInventoryLocationDialogModule
  ],
  exports: [InventoryLocationsSettingComponent],
})
export class InventoryLocationsSettingModule { }
